import { TransactionStatus } from 'src/type/transaction';

export const txStatusLabel = (status: TransactionStatus) => {
  switch (status) {
    case TransactionStatus.PENDING:
      return 'รอดำเนินการ';
    case TransactionStatus.SUCCESS:
      return 'สำเร็จ';
    case TransactionStatus.REJECTED:
      return 'ปฏิเสธ';
    case TransactionStatus.CANCEL:
      return 'ยกเลิก';
    default:
      return '';
  }
};

export const statusAction = (status?: TransactionStatus) => {
  switch (status) {
    case TransactionStatus.SUCCESS:
      return 'อนุมัติ';
    case TransactionStatus.REJECTED:
    case TransactionStatus.CANCEL:
      return 'ปฎิเสธ';
    default:
      return '';
  }
};
